const products = require('data/products.json');

const productDict = products.reduce((result, product) => {
  result[product.id] = product;
  return result;
}, {});

export default {
  getProduct(id) {
    return productDict[id];
  }
};



// WEBPACK FOOTER //
// ./src/services/product-database.js